/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import React from 'react';
import { Step, StepLabel, Stepper, styled } from "__barrel_optimize__?names=Step,StepLabel,Stepper,styled!=!@mui/material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ContactsIcon from '@mui/icons-material/Contacts';
import AddBoxIcon from '@mui/icons-material/AddBox';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
const steps = [
    {
        id: 1,
        name: 'Inspection Type'
    },
    {
        id: 2,
        name: 'Vehicle Information'
    },
    {
        id: 3,
        name: 'Contact Information'
    },
    {
        id: 4,
        name: 'Add-Ons'
    },
    {
        id: 5,
        name: 'Additional Notes'
    },
    {
        id: 6,
        name: 'Checkout'
    }
];
const ColorlibConnector = styled(StepConnector)((param)=>{
    let { theme } = param;
    return {
        ["&.".concat(stepConnectorClasses.alternativeLabel)]: {
            top: 22
        },
        ["&.".concat(stepConnectorClasses.active)]: {
            ["& .".concat(stepConnectorClasses.line)]: {
                backgroundColor: '#43bccd'
            }
        },
        ["&.".concat(stepConnectorClasses.completed)]: {
            ["& .".concat(stepConnectorClasses.line)]: {
                backgroundColor: '#43bccd'
            }
        },
        ["& .".concat(stepConnectorClasses.line)]: {
            height: 3,
            border: 0,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            ...theme.applyStyles('dark', {
                backgroundColor: theme.palette.grey[800]
            })
        }
    };
});
const ColorlibStepIconRoot = styled('div')((param)=>{
    let { theme } = param;
    return {
        backgroundColor: '#f5f5f5',
        zIndex: 1,
        color: '#a3a3a3',
        width: 40,
        height: 40,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[700]
        }),
        variants: [
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.active;
                },
                style: {
                    backgroundColor: '#43bccd',
                    color: '#fff'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.completed;
                },
                style: {
                    backgroundColor: '#43bccd',
                    color: '#fff'
                }
            }
        ]
    };
});
function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
    const icons = {
        1: /*#__PURE__*/ _jsx(ImageSearchIcon, {
            fontSize: "inherit"
        }),
        2: /*#__PURE__*/ _jsx(DirectionsCarIcon, {
            fontSize: "inherit"
        }),
        3: /*#__PURE__*/ _jsx(ContactsIcon, {
            fontSize: "inherit"
        }),
        4: /*#__PURE__*/ _jsx(AddBoxIcon, {
            fontSize: "inherit"
        }),
        5: /*#__PURE__*/ _jsx(TextSnippetIcon, {
            fontSize: "inherit"
        }),
        6: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
            fontSize: "inherit"
        })
    };
    return /*#__PURE__*/ _jsx(ColorlibStepIconRoot, {
        ownerState: {
            completed,
            active
        },
        className: className,
        children: icons[String(props.icon)]
    });
}
function CustomStepper() {
    const { step, setStep } = useNewOrder();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "hidden md:block",
                children: /*#__PURE__*/ _jsx(Stepper, {
                    activeStep: step - 1,
                    alternativeLabel: true,
                    connector: /*#__PURE__*/ _jsx(ColorlibConnector, {}),
                    children: steps.map((s)=>/*#__PURE__*/ _jsx(Step, {
                            children: /*#__PURE__*/ _jsx(StepLabel, {
                                StepIconComponent: ColorlibStepIcon
                            })
                        }, s.id))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "md:hidden flex flex-row",
                children: /*#__PURE__*/ _jsx("h3", {
                    children: steps[step - 1].name
                })
            })
        ]
    });
}
export default CustomStepper;
